import React from 'react';
import PropTypes from 'prop-types';


const VideoStatsString = ({ uid, videoStats }) => {
  const { count, duration } = videoStats[uid] || {};
  if (!count) {
    return null;
  }
  const minutesRounded = Math.round(duration / 60);
  const durationString = duration ? `, ${minutesRounded} minute${minutesRounded === 1 ? '' : 's'}` : '';
  const statsString = `(${count} video${count === 1 ? '' : 's'}${durationString})`;
  return <span className="meta">{statsString}</span>;
};

VideoStatsString.propTypes = {
  uid: PropTypes.string,
  videoStats: PropTypes.object,
};

export default VideoStatsString;



// WEBPACK FOOTER //
// ./src/components/TopicTree/VideoStatsString.js